import { ROUTES } from "./path"
import React from "react"
import { AppRouteConfig } from "@/types/navigation"
import QueryEditor from "@/pages/dashboard/editor/query-editor"

export const editorRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.EDITOR.QUERY_EDITOR,
    element: React.createElement(QueryEditor),
    restricted: true,
    showNav: true,
    showSideBar: false,
  },
]
